import React from 'react';
import { C1SignupData } from '../C1SignupFlow';
import CardDetails from './CardDetails';
import './PaymentMethodDetails.css';

interface PaymentDetailsProps {
  data: C1SignupData;
  onNext: (data: Partial<C1SignupData>) => void;
  onCancel: () => void;
}

// All payment methods (card, bank transfer, Apple Pay, Google Pay) are handled
// by Stripe's PaymentElement inside CardDetails.
const PaymentDetails: React.FC<PaymentDetailsProps> = ({ data, onNext, onCancel }) => (
  <CardDetails data={data} onNext={onNext} onCancel={onCancel} />
);

export default PaymentDetails;
